import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class CommunityService {
constructor(private http: HttpClient){

}
 updateCount:EventEmitter<boolean> = new EventEmitter();
 updateViewed:EventEmitter<boolean> = new EventEmitter();
// getData(projectId,param){
  
//     return this.http.get(environment.va_service_api+projectId+"/keinfo",param)
//       .map((response) => {
//         return response;
//       },
//         (err: Response) => {
//           console.log(err);
//         });
// }
getData(projectId, param) {
  return this.http.get(environment.va_service_api + projectId + "/keinfo", { params: param })
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error); // Rethrow the error to propagate it
      })
    );
}

// getQuestions(agentId,searchParams){
//   //?offset=0&limit10&search=text

//  // agentId + '/utterances/search?query='+ query +"&limit="+limit+"&offset="+offset
//   return this.http.get(environment.va_service_api+"retraining_dashboard/"+agentId+"/questions",{params:searchParams})
//   .map((response) => {
//     return response;
//   },
//     (err: Response) => {
//       console.log(err);
//     });
// }
getQuestions(agentId, searchParams) {
  return this.http.get(environment.va_service_api + "retraining_dashboard/" + agentId + "/questions", { params: searchParams })
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error); // Rethrow the error to propagate it
      })
    );
}

/*Restore Answer*/
// restoreAnswer(agentId,questionId,param){
//   return this.http.post(environment.va_service_api+"retraining_module/"+agentId+"/questions/"+questionId+"/restore",param)
//   .map((response) => {
//     return response;
//   },
//     (err: Response) => {
//       console.log(err);
//     });
// }
restoreAnswer(agentId, questionId, param) {
  return this.http.post(environment.va_service_api + "retraining_module/" + agentId + "/questions/" + questionId + "/restore", param)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error); // Rethrow the error to propagate it
      })
    );
}

// publishData(agent_id,answer_id,param){
  
//   return this.http.post(environment.va_service_api+"retraining_dashboard/"+agent_id+"/"+answer_id+"/publish",param)
//   .map((response) => {
//     return response;
//   },
//     (err: Response) => {
//       console.log(err);
//     });
// }
publishData(agent_id, answer_id, param) {
  return this.http.post(environment.va_service_api + "retraining_dashboard/" + agent_id + "/" + answer_id + "/publish", param)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

// getAnswers(agent_id,id){
  
//   return this.http.get(environment.va_service_api+"retraining_dashboard/"+agent_id+"/answers/"+id)
//   .map((response) => {
//     return response;
//   },
//     (err: Response) => {
//       console.log(err);
//     });
// }
getAnswers(agent_id, id) {
  return this.http.get(environment.va_service_api + "retraining_dashboard/" + agent_id + "/answers/" + id)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

// markAsViewed(agent_id,answer_id,param){
 
//   return this.http.post(environment.va_service_api+"retraining_dashboard/"+agent_id+"/"+answer_id+"/viewed",param)
//   .map((response) => {
//     return response;
//   },
//     (err: Response) => {
//       console.log(err);
//     });
// }
markAsViewed(agent_id, answer_id, param) {
  return this.http.post(environment.va_service_api + "retraining_dashboard/" + agent_id + "/" + answer_id + "/viewed", param)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

// getQuestionsCount(agentId){
//   return this.http.get(environment.va_service_api+"retraining_dashboard/"+agentId+"/questions/count")
//   .map((response) => {
//     return response;
//   },
//     (err: Response) => {
//       console.log(err);
//     });
// }
getQuestionsCount(agentId) {
  return this.http.get(environment.va_service_api + "retraining_dashboard/" + agentId + "/questions/count")
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

// deleteAnswer(agentId,questionId,param){
//   return this.http.post(environment.va_service_api+"retraining_module/"+agentId+"/questions/"+questionId+"/delete",param)
//   .map((response) => {
//     return response;
//   },
//     (err: Response) => {
//       console.log(err);
//     });
// }
deleteAnswer(agentId, questionId, param) {
  return this.http.post(environment.va_service_api + "retraining_module/" + agentId + "/questions/" + questionId + "/delete", param)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

/*Archive question*/
// archiveQuestion(agentId,questionId,param){
//   return this.http.post(environment.va_service_api+"retraining_module/"+agentId+"/questions/"+questionId+"/archive",param)
//   .map((response) => {
//     return response;
//   },
//     (err: Response) => {
//       console.log(err);
//     });
// }
archiveQuestion(agentId, questionId, param) {
  return this.http.post(environment.va_service_api + "retraining_module/" + agentId + "/questions/" + questionId + "/archive", param)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

// saveAnswerText(agentId,qustnId,answerId,param){
//   return this.http.put(environment.va_service_api+"retraining_module/"+agentId+"/"+qustnId+"/"+answerId+"/qa",param)
//   .map((response) => {
//     return response;
//   },
//     (err: Response) => {
//       console.log(err);
//     });
// }
saveAnswerText(agentId, qustnId, answerId, param) {
  return this.http.put(environment.va_service_api + "retraining_module/" + agentId + "/" + qustnId + "/" + answerId + "/qa", param)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

/*Update question after edit*/
// updateQuestion(agentId,questionId,param){
//   return this.http.put(environment.va_service_api+"retraining_module/"+agentId+"/"+questionId+"/qa",param)
//   .map((response) => {
//     return response;
//   },
//     (err: Response) => {
//       console.log(err);
//     });
// }
updateQuestion(agentId, questionId, param) {
  return this.http.put(environment.va_service_api + "retraining_module/" + agentId + "/" + questionId + "/qa", param)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

// addQuestionTag(agentId, questionId, params) {
//   return this.http.post(environment.va_service_api + 'retraining_dashboard/' + agentId + '/add-tag/' + questionId, params).map(
//     (response: Response) => {
//       return response;
//     }, (err: Response) => {
//       return err;
//     });
// }
addQuestionTag(agentId, questionId, params) {
  return this.http.post(environment.va_service_api + 'retraining_dashboard/' + agentId + '/add-tag/' + questionId, params)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

// deleteQuestionTag(agentId, questionId, params) {
//   return this.http.post(environment.va_service_api + 'retraining_dashboard/' + agentId + '/delete-tag/' + questionId, params).map(
//     (respnse: Response) => {
//       return respnse;
//     }, (err: Response) => {
//       return err;
//     }
//   );
// }
deleteQuestionTag(agentId, questionId, params) {
  return this.http.post(environment.va_service_api + 'retraining_dashboard/' + agentId + '/delete-tag/' + questionId, params)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

// getQuestionTags(agentId, questionId) {
//   return this.http.get(environment.va_service_api + 'retraining_dashboard/' + agentId + '/get-tags/' + questionId).map(
//     (result: Response) => {
//       return result;
//     }, (err) => {
//       return err;
//     }
//   );
// }
getQuestionTags(agentId, questionId) {
  return this.http.get(environment.va_service_api + 'retraining_dashboard/' + agentId + '/get-tags/' + questionId)
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

// getTags(agentId) {
//   return this.http.get(environment.va_service_api + 'retraining_dashboard/' + agentId + '/get-full-tags').map(
//     (result: Response) => {
//       return result;
//     }, (err) => {
//       return err;
//     }
//   )
// }
getTags(agentId) {
  return this.http.get(environment.va_service_api + 'retraining_dashboard/' + agentId + '/get-full-tags')
    .pipe(
      catchError((error: any) => {
        console.error(error);
        return throwError(error);
      })
    );
}

downloadCommunity(agentId, data){
  
  var HTTPOptions = {
    headers: new HttpHeaders({
      'Accept': 'application/pdf'
    }),
    'responseType': 'blob' as 'json'
  }

  return this.http.get(environment.va_service_api + 'retraining_module/' + agentId + '/download_community', HTTPOptions)
}

}